export const SLUZBY_RULES = {
  kremace: {
    title: "Kremace s obřadem",
    allowedIds: [
      "sjednani_obradu",
      "sjednani_obradu_online",
      "administrativa",
      "doprava_1km",
      "prevoz_krematorium_cb",
      "prevoz_pausal_ck",
      "chlazeni_24h",
      "mrazeni_24h",
      "kremace",
      "rakev",
      "vlozka_zinek",
      "rubas",
      "souprava",
      "poduska",
      "krajka",
      "krizky",
      "obleceni",
      "obleceni_rubase",
      "ustrojeni",
      "umyvani",
      "umyvani_obleceni_ulozeni_ustrojeni",
      "holeni",
      "liceni_malovani_nehtu",
      "ulozeni",
      "manipulace_rakvi_nositky",
      "manipulace_rakvi_pat",
      "manipulace_telo_abn_rakev",
      "rizeni_pohrebu",
      "obrad_vlastni",
      "pronajem_obradni_sin",
      "pronajem_kaple",
      "katafalk_obradni_sin",
      "pojizdny_katafalk",
      "reprodukovana_hudba",
      "reprodukovana_hudba_mimo_sin",
      "hra_na_varhany",
      "hra_varhany_s_dechovou",
      "zpev",
      "civilni_recnik_v_sini",
      "civilni_recnik_mimo_ck",
      "obradnik_v_sini_pouze_pri_hudbe",
      "obradnik_mimo_ck",
      "fotografie",
      "foto_zesnuleho",
      "video",
      "zaznam_z_obradu",
      "promitani_fotografii",
      "priprava_prezentace_do30",
      "priprava_prezentace_nad30",
      "online_prenos",
      "kvetiny_vazba",
      "kvetinova_vyzdoba",
      "kytice",
      "vence",
      "stuhy",
      "vystaveni_fotografie",
      "vystaveni_kytice_ks",
      "vystaveni_vence_ks",
      "vystaveni_kvetinove_vyzdoby_1ks",
      "tiskparte",
      "umrtni_oznameni",
      "kondolencni_kniha",
      "urne_standard",
      "urne_lux",
      "uredni_urna",
      "manipulace_urnou",
      "otevreni_a_zalepeni_urny",
      "odsyp_popela",
      "privezeni_urny_cb"
    ],
  },

  kremace_bez_obradu: {
    title: "Kremace bez obřadu",
    allowedIds: [
      "sjednani_zpopelneni_bez_obradu",
      "doprava_1km",
      "prevoz_krematorium_cb",
      "prevoz_pausal_ck",
      "chlazeni_24h",
      "mrazeni_24h",
      "kremace",
      "rakev",
      "vlozka_zinek",
      "rubas",
      "souprava",
      "poduska",
      "krajka",
      "krizky",
      "obleceni",
      "obleceni_rubase",
      "ustrojeni",
      "umyvani",
      "umyvani_obleceni_ulozeni_ustrojeni",
      "holeni",
      "liceni_malovani_nehtu",
      "manipulace_rakvi_nositky",
      "manipulace_rakvi_pat",
      "manipulace_telo_abn_rakev",
      "cekaci_doba_zapocata_hod",
      "ukony_zamestnancu",
      "rezijni_naklady_bez_obradu",
      "urne_standard",
      "urne_lux",
      "uredni_urna",
      "manipulace_urnou",
      "otevreni_a_zalepeni_urny",
      "odsyp_popela",
      "privezeni_urny_cb",
      "rizeni_pohrebu",
      "obrad_s_urnou_zapujceni_rakve",
      "obrad_s_urnou_zapujceni_urny",
      "pronajem_obradni_sin",
      "pronajem_kaple",
      "katafalk_obradni_sin",
      "pojizdny_katafalk",
      "reprodukovana_hudba",
      "reprodukovana_hudba_mimo_sin",
      "hra_na_varhany",
      "hra_varhany_s_dechovou",
      "zpev",
      "civilni_recnik_v_sini",
      "civilni_recnik_mimo_ck",
      "obradnik_v_sini_pouze_pri_hudbe",
      "obradnik_mimo_ck",
      "fotografie",
      "video",
      "zaznam_z_obradu",
      "promitani_fotografii",
      "priprava_prezentace_do30",
      "priprava_prezentace_nad30",
      "online_prenos",
      "kvetinova_vyzdoba",
      "kytice",
      "vence",
      "stuhy",
      "vystaveni_fotografie",
      "vystaveni_kytice_ks",
      "vystaveni_vence_ks",
      "vystaveni_kvetinove_vyzdoby_1ks",
      "administrativa",
      "tiskparte",
      "umrtni_oznameni",
      "kondolencni_kniha"
    ],
  },

  pohreb: {
    title: "Pohřeb",
    allowedIds: [
      "sjednani_obradu",
      "sjednani_obradu_online",
      "administrativa",
      "tiskparte",
      "umrtni_oznameni",
      "kondolencni_kniha",

      "doprava_1km",
      "prevoz_pausal_ck",
      "chlazeni_24h",
      "mrazeni_24h",
      "manipulace_rakvi_nositky",
      "manipulace_rakvi_pat",
      "manipulace_telo_abn_rakev",
      "ulozeni",

      "rakev",
      "vlozka_zinek",
      "rubas",
      "souprava",
      "poduska",
      "krajka",
      "krizky",
      "obleceni",
      "obleceni_rubase",
      "ustrojeni",
      "umyvani",
      "umyvani_obleceni_ulozeni_ustrojeni",
      "holeni",
      "liceni_malovani_nehtu",

      "rizeni_pohrebu",
      "obrad_vlastni",
      "pronajem_obradni_sin",
      "pronajem_kaple",
      "katafalk_obradni_sin",
      "pojizdny_katafalk",
      "reprodukovana_hudba",
      "reprodukovana_hudba_mimo_sin",
      "hra_na_varhany",
      "hra_varhany_s_dechovou",
      "zpev",
      "civilni_recnik_v_sini",
      "civilni_recnik_mimo_ck",
      "civilni_recnik_ke_hrobu",
      "obradnik_v_sini_pouze_pri_hudbe",
      "obradnik_mimo_ck",

      "fotografie",
      "foto_zesnuleho",
      "video",
      "zaznam_z_obradu",
      "promitani_fotografii",
      "priprava_prezentace_do30",
      "priprava_prezentace_nad30",
      "online_prenos",

      "kvetiny_vazba",
      "kvetinova_vyzdoba",
      "kytice",
      "vence",
      "stuhy",
      "vystaveni_fotografie",
      "vystaveni_kytice_ks",
      "vystaveni_vence_ks",
      "vystaveni_kvetinove_vyzdoby_1ks"
    ],
  },

  alternativa: {
    title: "Alternativní rozloučení",
    allowedIds: [
      "sjednani_obradu",
      "sjednani_obradu_online",
      "administrativa",
      "doprava_1km",
      "prevoz_pausal_ck",
      "chlazeni_24h",
      "mrazeni_24h",
      "rakev",
      "vlozka_zinek",
      "rubas",
      "souprava",
      "poduska",
      "krajka",
      "krizky",
      "obleceni",
      "obleceni_rubase",
      "ustrojeni",
      "umyvani",
      "umyvani_obleceni_ulozeni_ustrojeni",
      "holeni",
      "liceni_malovani_nehtu",
      "manipulace_rakvi_nositky",
      "manipulace_rakvi_pat",
      "manipulace_telo_abn_rakev",
      "rizeni_pohrebu",
      "alternativni_misto_organizace",
      "asistence_alternativni_rozlouceni_hod",
      "civilni_recnik_mimo_ck",
      "reprodukovana_hudba_mimo_sin",
      "fotografie",
      "video",
      "zaznam_z_obradu",
      "promitani_fotografii",
      "priprava_prezentace_do30",
      "priprava_prezentace_nad30",
      "online_prenos",
      "kvetinova_vyzdoba",
      "kytice",
      "vence",
      "stuhy",
      "tiskparte",
      "umrtni_oznameni",
      "kondolencni_kniha"
    ],
  },

  obrad_s_urnou: {
    title: "Obřad s urnou",
    allowedIds: [
      "sjednani_obradu",
      "sjednani_obradu_online",
      "administrativa",
      "manipulace_urnou",
      "urne_standard",
      "urne_lux",
      "uredni_urna",
      "otevreni_a_zalepeni_urny",
      "odsyp_popela",
      "privezeni_urny_cb",
      "rizeni_pohrebu",
      "obrad_s_urnou_zapujceni_rakve",
      "obrad_s_urnou_zapujceni_urny",
      "pronajem_obradni_sin",
      "pronajem_kaple",
      "katafalk_obradni_sin",
      "pojizdny_katafalk",
      "reprodukovana_hudba",
      "reprodukovana_hudba_mimo_sin",
      "hra_na_varhany",
      "hra_varhany_s_dechovou",
      "zpev",
      "civilni_recnik_v_sini",
      "civilni_recnik_mimo_ck",
      "obradnik_v_sini_pouze_pri_hudbe",
      "obradnik_mimo_ck",
      "fotografie",
      "video",
      "zaznam_z_obradu",
      "promitani_fotografii",
      "priprava_prezentace_do30",
      "priprava_prezentace_nad30",
      "online_prenos",
      "kvetinova_vyzdoba",
      "kytice",
      "vence",
      "stuhy",
      "vystaveni_fotografie",
      "vystaveni_kytice_ks",
      "vystaveni_vence_ks",
      "vystaveni_kvetinove_vyzdoby_1ks",
      "tiskparte",
      "umrtni_oznameni",
      "kondolencni_kniha"
    ],
  },

  prevoz: {
    title: "Samostatný převoz",
    allowedIds: [
      "doprava_1km",
      "prevoz_pausal_ck",
      "prevoz_krematorium_cb",
      "chlazeni_24h",
      "mrazeni_24h",
      "manipulace_rakvi_nositky",
      "manipulace_rakvi_pat",
      "manipulace_telo_abn_rakev",
      "administrativa"
    ],
  },

  ostatni: {
    title: "Ostatní",
    allowedIds: null,
  },
};

export function getRulesForTypZakazky(typZakazky) {
  const key = String(typZakazky || "").trim();
  return SLUZBY_RULES[key] || SLUZBY_RULES.ostatni;
}

export function isServiceAllowedForTyp(typZakazky, id) {
  const rules = getRulesForTypZakazky(typZakazky);
  if (!Array.isArray(rules?.allowedIds)) return true;
  return rules.allowedIds.includes(String(id || "").trim());
}
